module.exports = __webpack_public_path__ + "img/pickup_parked.b66b4fd1.svg";